module.exports = __webpack_public_path__ + "img/img-yingjian-s4.81d8e13f.jpg";